/* Mod City Madness: tidy collection pages (runs after the page's own layout script) */
(function(){
  if(window.__mcmTidy)return;window.__mcmTidy=1;
  function tidy(){
    var pad=document.querySelector("[class*='product-grid-padding']");if(!pad)return false;
    var grid=pad.closest('.shopify-section')||pad.parentElement;
    var hero=document.querySelector('.mcm-hero-banner');
    var rte=document.querySelector('.collection-hero__description.rte');
    if(rte&&rte.querySelector('.mcm-hero-banner'))return false; /* page script has not moved things yet */
    document.body.classList.add('mcm-tidy');
    /* 1. wall bar right above filters and products */
    var bar=document.querySelector('[data-mcmfit-bar]');
    if(bar){var wrap=bar.parentElement;wrap.classList.add('mcm-fit-moved');if(pad.parentNode)pad.parentNode.insertBefore(wrap,pad)}
    /* 2. long writing that sat above the products moves below them */
    var below=document.querySelector('.mcm-below-grid');
    var movers=[].slice.call(grid.querySelectorAll(':scope > .mcm-styling, :scope > p[style*="border-left"], :scope > div[style*="grid-template-columns"]'));
    if(!below&&movers.length){below=document.createElement('div');below.className='mcm-below-grid';grid.parentNode.insertBefore(below,grid.nextSibling)}
    movers.reverse().forEach(function(el){below.insertBefore(el,below.firstChild)});
    /* 3. fold it behind Read more */
    if(below&&!below.classList.contains('mcm-folded')&&below.scrollHeight>380){
      below.classList.add('mcm-folded');
      var w=document.createElement('div');w.className='mcm-readmore-wrap';
      w.innerHTML='<button type="button" class="mcm-readmore" aria-expanded="false">Read more</button>';
      below.parentNode.insertBefore(w,below.nextSibling);
      var b=w.firstChild;b.addEventListener('click',function(){var open=below.classList.toggle('mcm-folded');b.textContent=open?'Read more':'Show less';b.setAttribute('aria-expanded',open?'false':'true');if(open)below.scrollIntoView({block:'start'})});
    }
    return true;
  }
  var tries=0;(function go(){if(tidy())return;if(++tries<40)setTimeout(go,100)})();
})();
